export const API_URL = "https://api.aircabi.co.uk/api/";
export const VEHICLE_IMAGE_BASE_URL = "https://api.aircabi.co.uk/public/assets/upload/";